import { inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { ReportPeriod } from '../models';
import { WINDOW } from '../../../providers/window.provider';

@Injectable({
  providedIn: 'root',
})
export class AssetManagementRoutingService {
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);
  readonly window = inject(WINDOW);
  readonly location = inject(Location);

  get routeQueryParams(): Record<string, string> {
    return this.route.snapshot.queryParams;
  }

  updateRouteQueryParams(params: Record<string, string>): void {
    const queryString = new URLSearchParams(params).toString();
    const newUrl = this.window.location.pathname + (queryString ? `?${queryString}` : '');
    this.location.replaceState(newUrl);
  }

  retrieveQueryParamsFilters(
    reportPeriodTrigger: BehaviorSubject<ReportPeriod>,
    filtersLoaded?: Subject<void>,
    searchTrigger?: BehaviorSubject<string>,
  ): void {
    if (this.extractReportPeriodFromQueryParams()) {
      reportPeriodTrigger.next(this.extractReportPeriodFromQueryParams());
    }

    if (this.extractQFromQueryParams()) {
      searchTrigger?.next(this.extractQFromQueryParams());
    }

    filtersLoaded?.next();
  }

  extractReportPeriodFromQueryParams(): ReportPeriod | null {
    const { key, start_date, end_date } = this.routeQueryParams;

    if (key && start_date && end_date) {
      return { key, start_date, end_date };
    }

    return null;
  }

  extractQFromQueryParams(): string | null {
    return this.routeQueryParams?.q || null;
  }
}
